export interface AddressInput {
  prename?: string;
  lastname?: string;
  street?: string;
  address_addition?: string;
  city?: string;
  zip?: string;
  country?: string;
  country_code?: string;
}

interface AddrLines {
  line1?: string;
  line2?: string;
  line3?: string;
  line4?: string;
  line5?: string;
}

export const ADDRESS_TEMPLATES: Record<string, (a: AddressInput) => AddrLines> = {
  'US': address => ({
    line1: [address.prename, address.lastname].filter(Boolean).join(' '),
    line2: address.street,
    line3: address.address_addition,
    line4: [address.city, address.zip].filter(Boolean).join(' '),
    line5: address.country
  }),
  'DE': address => ({
    line1: [address.prename, address.lastname].filter(Boolean).join(' '),
    line2: address.street,
    line3: address.address_addition,
    line4: [address.zip, address.city].filter(Boolean).join(' '),
    line5: address.country
  }),
  'CH': address => ({
    line1: [address.prename, address.lastname].filter(Boolean).join(' '),
    line2: address.street,
    line3: address.address_addition,
    line4: [address.zip, address.city].filter(Boolean).join(' '),
    line5: address.country
  }),
  'AT': address => ({
    line1: [address.prename, address.lastname].filter(Boolean).join(' '),
    line2: address.street,
    line3: address.address_addition,
    line4: [address.zip, address.city].filter(Boolean).join(' '),
    line5: address.country
  }),
  'GB': address => ({
    line1: [address.prename, address.lastname].filter(Boolean).join(' '),
    line2: address.address_addition,
    line3: address.street,
    line4: [address.city, address.zip].filter(Boolean).join(' '),
    line5: address.country
  }),
  'FR': address => ({
    line1: [address.prename, address.lastname].filter(Boolean).join(' '),
    line2: address.street,
    line3: address.address_addition,
    line4: [address.zip, address.city].filter(Boolean).join(' '),
    line5: address.country
  }),
  'IT': address => ({
    line1: [address.prename, address.lastname].filter(Boolean).join(' '),
    line2: address.street,
    line3: address.address_addition,
    line4: [address.zip, address.city].filter(Boolean).join(' '),
    line5: address.country
  }),
  'ES': address => ({
    line1: [address.prename, address.lastname].filter(Boolean).join(' '),
    line2: address.street,
    line3: address.address_addition,
    line4: [address.zip, address.city].filter(Boolean).join(' ')
  }),
  'NL': address => ({
    line1: [address.prename, address.lastname].filter(Boolean).join(' '),
    line2: address.street,
    line3: address.address_addition,
    line4: [address.zip, address.city].filter(Boolean).join(' '),
    line5: address.country
  }),
  'BE': address => ({
    line1: [address.prename, address.lastname].filter(Boolean).join(' '),
    line2: address.street,
    line3: address.address_addition,
    line4: [address.zip, address.city].filter(Boolean).join(' ')
  }),
  'PL': address => ({
    line1: [address.prename, address.lastname].filter(Boolean).join(' '),
    line2: address.street,
    line3: address.address_addition,
    line4: [address.zip, address.city].filter(Boolean).join(' '),
    line5: address.country
  }),
  'CZ': address => ({
    line1: [address.prename, address.lastname].filter(Boolean).join(' '),
    line2: address.street,
    line3: address.address_addition,
    line4: [address.zip, address.city].filter(Boolean).join(' '),
    line5: address.country
  }),
  'HU': address => ({
    line1: [address.prename, address.lastname].filter(Boolean).join(' '),
    line2: address.street,
    line3: address.address_addition,
    line4: [address.zip, address.city].filter(Boolean).join(' '),
    line5: address.country
  }),
  'RO': address => ({
    line1: [address.prename, address.lastname].filter(Boolean).join(' '),
    line2: address.street,
    line3: address.address_addition,
    line4: [address.zip, address.city].filter(Boolean).join(' '),
    line5: address.country
  }),
  'BG': address => ({
    line1: [address.prename, address.lastname].filter(Boolean).join(' '),
    line2: address.street,
    line3: address.address_addition,
    line4: [address.zip, address.city].filter(Boolean).join(' '),
    line5: address.country
  }),
  'SE': address => ({
    line1: [address.prename, address.lastname].filter(Boolean).join(' '),
    line2: address.street,
    line3: address.address_addition,
    line4: [address.zip, address.city].filter(Boolean).join(' '),
    line5: address.country
  }),
  'DK': address => ({
    line1: [address.prename, address.lastname].filter(Boolean).join(' '),
    line2: address.street,
    line3: address.address_addition,
    line4: [address.zip, address.city].filter(Boolean).join(' '),
    line5: address.country
  }),
  'NO': address => ({
    line1: [address.prename, address.lastname].filter(Boolean).join(' '),
    line2: address.street,
    line3: address.address_addition,
    line4: [address.zip, address.city].filter(Boolean).join(' '),
    line5: address.country
  }),
  'FI': address => ({
    line1: [address.prename, address.lastname].filter(Boolean).join(' '),
    line2: address.street,
    line3: address.address_addition,
    line4: [address.zip, address.city].filter(Boolean).join(' '),
    line5: address.country
  }),
  'IS': address => ({
    line1: [address.prename, address.lastname].filter(Boolean).join(' '),
    line2: address.street,
    line3: address.address_addition,
    line4: [address.zip, address.city].filter(Boolean).join(' '),
    line5: address.country
  }),
  'AU': address => ({
    line1: [address.prename, address.lastname].filter(Boolean).join(' '),
    line2: address.street,
    line3: address.address_addition,
    line4: [address.city, address.zip].filter(Boolean).join(' '),
    line5: address.country
  }),
  'NZ': address => ({
    line1: [address.prename, address.lastname].filter(Boolean).join(' '),
    line2: address.street,
    line3: address.address_addition,
    line4: [address.city, address.zip].filter(Boolean).join(' '),
    line5: address.country
  }),
};
